import { Reset } from '@hendrx/icons/Reset';
import { Button } from '@mantine/core';

import classes from './ResetButton.module.scss';

type ButtonResetProps = {
  onClick: () => void;
  disabled?: boolean;
  dataTestId?: string;
};

// This is a very simple reset button for imitating ClearActivityStyleProperty button
// Upcoming refactor will use a similar solution for resetting content object's theme styling
export function ResetButton(props: ButtonResetProps) {
  const { onClick, disabled, dataTestId } = props;
  return (
    <Button
      className={classes.clearButton}
      size="compact-md"
      onClick={onClick}
      disabled={disabled}
      data-testid={dataTestId}
    >
      <Reset className={classes.clearIcon} />
    </Button>
  );
}
